module.exports = __webpack_public_path__ + "media/fonts/american_typewriter-webfont-77aa855425020c66979d9be39fcae875.woff2";